import CoachAverageRatingCard from './coach-average-rating-card'

export default CoachAverageRatingCard
